import { isAicopyCouponPosition } from "./couponPositionFields";

/** @deprecated 使用 isAicopyCouponPosition */
export function isAicopyCouponFollowOrder(raw) {
  return isAicopyCouponPosition(raw);
}

/** 跟单卡片右上角角标类型：体验券 Voucher / 金额跟单 Cash */
export function getAicopyOrderCardCornerVariant(raw) {
  return isAicopyCouponPosition(raw) ? "voucher" : "cash";
}
